import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getDepartments = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Department/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export const saveDepartment = async (dept) => {
  const response = await axios.post(`${BASE_URL}/api/Department/save`, dept, {
    headers: getAuthHeader(),
  });
  return response.data;
};
